import Iodine from '@kingshott/iodine';

export const formValidation = () => {
      console.log('form validation set');
    // Form Validation
    // Flag for whether the form is valid
    let valid = false;

    // Define the validation rules
    const rules = {
        username : ['required', 'string', 'minimum:3', 'maximum:30'],
        email    : ['required', 'string', 'minimum:6', 'maximum:255', 'email'],
    };


    /**
     * Validate the registration form and submit it.
     *
     **/
    function register(event)
    {
        // Prevent the standard submission of the form
        event.preventDefault();

        // Reset the flag
        valid = true;

        // Iterate through the form fields
        for (const field in rules) {

            // Locate the field's input and validation span
            let input   = document.getElementById(field);
            let message = input.nextElementSibling;

            // Hide all existing messages
            message.classList.add('hidden');

            // Validate the field's value
            let result = Iodine.is(input.value, rules[field]);

            // Handle any failed validation
            if (result !== true) {

                // Toggle the flag
                valid = false;

                // Update the form
                message.classList.remove('hidden');
                message.innerHTML = Iodine.getErrorMessage(result);

            }
        }

        // Check whether to submit the form
        if (valid) {
            document.getElementById('contact').submit();
        }
    }
}
